import { ApiKeys } from '@app/constants/api-keys'
import { IInstitutionSubType } from '@app/interfaces/organization/institution-subtype'
import { resolveTParams } from '@app/utils/resolve-params/resolve-params'
import localforage from 'localforage'
import { emptyOrganizationApi } from '.'
import { IRtkResponse } from '../../types'

export const institutionSubTypeApi = emptyOrganizationApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getInstitutionSubTypes: build.query<
      IRtkResponse<IInstitutionSubType[]>,
      URLSearchParams | string
    >({
      query: (args = '') => ({
        url: 'dictionary/api/v1/institution-sub-types',
        method: 'get',
        params: {
          ...resolveTParams(args),
        },
      }),
      transformResponse: (response: IInstitutionSubType[], meta) => {
        return { response, meta }
      },
      providesTags: (data) =>
        data
          ? [
              ...data.response.map(({ id }) => ({
                type: ApiKeys.institutionSubType,
                id,
              })),
              { type: ApiKeys.institutionSubType, id: 'LIST' },
            ]
          : [{ type: ApiKeys.institutionSubType, id: 'LIST' }],
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          localforage.setItem(ApiKeys.institutionSubType, data?.response)
        } catch (e) {
          console.error(e)
        }
      },
    }),
    getInstitutionSubType: build.query<IInstitutionSubType, number>({
      query: (id) => ({
        url: `dictionary/api/v1/institution-sub-types/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [
        { type: ApiKeys.institutionSubType, id },
      ],
    }),
  }),
})

export const { useGetInstitutionSubTypesQuery, useGetInstitutionSubTypeQuery } =
  institutionSubTypeApi
